import isNil from 'lodash/isNil';

import { IssueStatus } from '@qality/common-model';

import { ALL_ISSUE_STATUSES, IssueStatusOption } from './IssueStatusPicker';

function mapStatusesToSelectOptions(
  statuses: Array<IssueStatus>
): Array<IssueStatusOption> {
  if (isNil(statuses)) {
    return [ALL_ISSUE_STATUSES];
  }
  const issueStatusesMap = new Map();

  statuses.forEach((status) => {
    if (!issueStatusesMap.has(status.name)) {
      issueStatusesMap.set(status.name, {
        label: status.name,
        value: [status],
      });
    } else {
      issueStatusesMap.get(status.name).value.push(status);
    }
  });

  return Array.from(issueStatusesMap.values());
}

function mapSelectOptionsToStatuses(
  issueStatusOptions: Array<IssueStatusOption>
): Array<IssueStatus> {
  return issueStatusOptions[issueStatusOptions.length - 1].value === null
    ? null
    : issueStatusOptions.map((option) => option.value).flat();
}

function filterOutAllStatusesOption(
  options: Array<IssueStatusOption>
): Array<IssueStatusOption> {
  return options.filter((option) => option.value !== null);
}

function getIssueStatusOptions(
  issueStatuses: Array<IssueStatus>
): Array<IssueStatusOption> {
  return [ALL_ISSUE_STATUSES, ...mapStatusesToSelectOptions(issueStatuses)];
}

export {
  mapStatusesToSelectOptions,
  mapSelectOptionsToStatuses,
  filterOutAllStatusesOption,
  getIssueStatusOptions,
};
